import type { JsonSuccess } from '@skynet/data-ws-core';

export enum ReportType {
  EmailGeneral = 0,
  EmailExportTrades = 2,
}

interface LoanId {
  loanId: string;
}
interface ProjectId {
  projectId: string;
}
interface AccountId {
  accountID: string;
}

interface TraderId {
  traderID: string;
}

type RequestReportTypeId = LoanId | ProjectId | AccountId | TraderId;

export interface RequestReportPayloadBase {
  accounts: string[];
  startDate: string;
  endDate: string;
  report: ReportType;
  supportedPairsOnly: boolean;
}

export type RequestReportPayload = RequestReportPayloadBase & RequestReportTypeId;

export interface ConfirmReportPayload {
  id: number;
}

export type JsonReportCommand = 'GetReport' | 'SendReport' | 'CancelReport';

export interface JsonReportSuccess extends JsonSuccess {
  okCommand: JsonReportCommand;
  id: number;
  result: string;
}

export enum ReportCommands {
  GetReport = 'GetReport',
  SendReport = 'SendReport',
  CancelReport = 'CancelReport',
}
